import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarRange, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatDateID, localeId } from "@/lib/format";

const toKey = (d) => (d ? format(d, "yyyy-MM-dd") : "");

const label = (from, to) => {
  if (!from) return "Semua Tanggal Masuk";
  if (!to || to === from) return formatDateID(from, "d MMM yyyy");
  return `${formatDateID(from, "d MMM yyyy")} – ${formatDateID(to, "d MMM yyyy")}`;
};

export const DateRangeFilter = ({ from, to, onChange }) => {
  const [open, setOpen] = useState(false);
  const selected = from ? { from: parseISO(from), to: to ? parseISO(to) : undefined } : undefined;

  const select = (range) => onChange({ from: toKey(range?.from), to: toKey(range?.to || range?.from) });

  return (
    <div className="relative md:w-64">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="flex h-10 w-full items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 pr-9 text-left text-sm text-slate-900 transition-colors hover:border-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/30"
            data-testid="date-filter-btn"
          >
            <CalendarRange className="h-4 w-4 shrink-0 text-emerald-600" />
            <span className="truncate" data-testid="date-filter-value">{label(from, to)}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto rounded-2xl p-0" align="start" data-testid="date-filter-calendar">
          <Calendar mode="range" selected={selected} onSelect={select} locale={localeId} disabled={{ after: new Date() }} numberOfMonths={1} initialFocus />
          <p className="border-t border-slate-100 px-4 py-2.5 text-xs text-slate-500">Klik satu tanggal, atau klik tanggal awal lalu tanggal akhir.</p>
        </PopoverContent>
      </Popover>
      {from && (
        <button
          type="button"
          onClick={() => onChange({ from: "", to: "" })}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
          aria-label="Hapus filter tanggal"
          data-testid="date-filter-clear-btn"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
};
